Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TikTok = void 0;

var _react = _interopRequireDefault(require("react"));

var _generalObserver = require("../general-observer");

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TikTok = function TikTok(_ref) {
  var tikTokId = _ref.tikTokId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    onEnter: function onEnter() {
      return (0, _utils.handleTikTokLoad)();
    }
  }, /*#__PURE__*/_react["default"].createElement("blockquote", {
    className: "tiktok-embed",
    cite: "https://www.tiktok.com/".concat(tikTokId),
    "data-video-id": tikTokId.split('/').pop()
  }, /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://tiktok.com/".concat(tikTokId)
  }, typeof window !== 'undefined' && !window.tiktok ? 'Loading' : ''))));
};

exports.TikTok = TikTok;